module.exports = __webpack_public_path__ + "static/media/xoleg_severe_right.3b80e237.png";